<template>
  <!-- 东国资讯页面 -->
  <div class="dongguozixun">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="titlebox">
      <p class="title">东国资讯</p>
      <div class="line"></div>
    </div>
    <div class="information">
      <!-- 东国资讯推荐 -->
      <div class="dongguozixunbox">
        <div class="topbox">
          <div class="line"></div>
          <p class="text">东国资讯推荐</p>
          <!-- <a href="" target="_blank" class="btnmore">更多></a> -->
        </div>
        <ul class="list_Oul">
          <li v-for="(item, index1) in arrLIst1" :key="index1">
            <p class="abroadbox_text" @click="handleClick(item, index1)">
              {{ item.Extend1 }}
            </p>
            <div class="lablebox">
              <a
                v-for="(itemlable, indexlable) in item.WebSiteLabelList"
                :key="indexlable"
                :href="
                  '/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'
                "
                target="_blank"
                class="abroadbox_lable"
                >{{ itemlable.WebSiteLabelName }}</a
              >
            </div>
          </li>
        </ul>
        <!-- <a href="javascript:;" class="problem_more" @click="LoadMore1">{{
        jzTxt1
      }}</a> -->
      </div>
      <!-- 校园资讯 -->
      <div class="xiaoyuanzixunbox">
        <div class="topbox">
          <div class="line"></div>
          <p class="text">校园资讯</p>
          <a href="/xiaoyuanzixun.html" target="_blank" class="btnmore"
            >更多></a
          >
        </div>
        <ul class="list_Oul">
          <li v-for="(item, index2) in arrLIst2" :key="index2">
            <p class="abroadbox_text" @click="handleClick(item, index2)">
              {{ item.Extend1 }}
            </p>
            <div class="lablebox">
              <a
                v-for="(itemlable, indexlable) in item.WebSiteLabelList"
                :key="indexlable"
                :href="
                  '/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'
                "
                target="_blank"
                class="abroadbox_lable"
                >{{ itemlable.WebSiteLabelName }}</a
              >
            </div>
          </li>
        </ul>
        <!-- <a href="javascript:;" class="problem_more" @click="LoadMore2">{{
        jzTxt2
      }}</a> -->
      </div>
      <!-- 海归政策 -->
      <div class="haiguizhengcebox">
        <div class="topbox">
          <div class="line"></div>
          <p class="text">海归政策</p>
          <a href="/haiguizhengce.html" target="_blank" class="btnmore"
            >更多></a
          >
        </div>
        <ul class="list_Oul">
          <li v-for="(item, index3) in arrLIst3" :key="index3">
            <p class="abroadbox_text" @click="handleClick(item, index3)">
              {{ item.Extend1 }}
            </p>
            <div class="lablebox">
              <a
                v-for="(itemlable, indexlable) in item.WebSiteLabelList"
                :key="indexlable"
                :href="
                  '/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'
                "
                target="_blank"
                class="abroadbox_lable"
                >{{ itemlable.WebSiteLabelName }}</a
              >
            </div>
          </li>
        </ul>
        <!-- <a href="javascript:;" class="problem_more" @click="LoadMore3">{{
        jzTxt3
      }}</a> -->
      </div>
      <!-- 留学解答 -->
      <div class="liuxuejiedabox">
        <div class="topbox">
          <div class="line"></div>
          <p class="text">留学解答</p>
          <a href="/application.html" target="_blank" class="btnmore">更多></a>
        </div>
        <ul class="list_Oul">
          <li v-for="(item, index4) in arrLIst4" :key="index4">
            <p class="abroadbox_text" @click="handleClick(item, index4)">
              {{ item.Extend1 }}
            </p>
            <div class="lablebox">
              <a
                v-for="(itemlable, indexlable) in item.WebSiteLabelList"
                :key="indexlable"
                :href="
                  '/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'
                "
                target="_blank"
                class="abroadbox_lable"
                >{{ itemlable.WebSiteLabelName }}</a
              >
            </div>
          </li>
        </ul>
        <!-- <a href="javascript:;" class="problem_more" @click="LoadMore4">{{
        jzTxt4
      }}</a> -->
      </div>
      <!-- 热门标签 -->
      <div class="remenbiaoqian">
        <div class="topbox">
          <div class="line"></div>
          <p class="text">热门标签</p>
        </div>
        <div class="lablebox">
          <a
            v-for="(item, index) in LabelList"
            :key="index"
            :href="'/biaoqianpage/1-' + item.LabelName + '.html'"
            target="_blank"
            class="abroadbox_lable"
            >{{ item.LabelName }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
export default {
  name: "dongguozixun",
  metaInfo() {
    return {
      title: `东国资讯-韩国东国大学中文官网`,
      meta: [
        {
          name: "keywords",
          content: "校园资讯,海归政策,留学解答 ",
        },
        {
          name: "description",
          content:
            "韩国东国大学中文官网为留学生提供韩国东国大学校园资讯、留学生活、留学解答、海归政策、留学资讯等，韩国东国大学中文官网全程为您的韩国留学生涯保驾护航。",
        },
      ],
    };
  },
  data() {
    return {
      //东国资讯
      jzTxt1: "点击加载更多",
      arrLIst1: [],
      isLoad1: true,
      //分页
      pagination1: {
        // 总条数
        total1: 0,
        // 当前页码
        currentPage1: 1,
        // 默认多少条数
        pagesize1: 4,
      },
      //校园资讯
      jzTxt2: "点击加载更多",
      arrLIst2: [],
      isLoad2: true,
      //分页
      pagination2: {
        // 总条数
        total2: 0,
        // 当前页码
        currentPage2: 1,
        // 默认多少条数
        pagesize2: 4,
      },
      //海归政策
      jzTxt3: "点击加载更多",
      arrLIst3: [],
      isLoad3: true,
      //分页
      pagination3: {
        // 总条数
        total3: 0,
        // 当前页码
        currentPage3: 1,
        // 默认多少条数
        pagesize3: 4,
      },
      //留学解答
      jzTxt4: "点击加载更多",
      arrLIst4: [],
      isLoad4: true,
      //分页
      pagination4: {
        // 总条数
        total4: 0,
        // 当前页码
        currentPage4: 1,
        // 默认多少条数
        pagesize4: 4,
      },
      //标签
      LabelList: [],
    };
  },
  activated() {
    this.$emit("handleTKD", "东国资讯");
  },
  mounted() {
    //东国资讯
    this.getData1();
    //校园资讯
    this.getData2();
    //海归政策
    this.getData3();
    //留学解答
    this.getData4();
    //标签列表
    this.getLableData();
  },
  methods: {
    //加载更多 东国资讯
    LoadMore1() {
      if (!this.isLoad1) return false;
      this.getData1();
    },
    //加载更多 校园资讯
    LoadMore2() {
      if (!this.isLoad2) return false;
      this.getData2();
    },
    //加载更多 海归政策
    LoadMore3() {
      if (!this.isLoad3) return false;
      this.getData3();
    },
    //加载更多 留学解答
    LoadMore4() {
      if (!this.isLoad4) return false;
      this.getData4();
    },
    //初始化列表  东国资讯
    getData1() {
      this.jzTxt1 = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuList: [427, 428, 509],
          index: this.pagination1.currentPage1,
          size: this.pagination1.pagesize1,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst1 = this.arrLIst1.concat(res.data.Data.list);
            //   // 加载状态结束
            this.jzTxt1 = "点击加载更多";
            //   // 数据全部加载完成
            if (this.arrLIst1.length >= res.data.DataCount) {
              this.isLoad1 = false;
              this.jzTxt1 = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination1.currentPage1++;
    },
    //初始化列表  校园资讯
    getData2() {
      this.jzTxt2 = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuId: 427,
          Index: this.pagination2.currentPage2,
          Size: this.pagination2.pagesize2,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst2 = this.arrLIst2.concat(res.data.Data.list);
            //   // 加载状态结束
            this.jzTxt2 = "点击加载更多";
            //   // 数据全部加载完成
            if (this.arrLIst2.length >= res.data.DataCount) {
              this.isLoad2 = false;
              this.jzTxt2 = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination2.currentPage2++;
    },
    //初始化列表  海归政策
    getData3() {
      this.jzTxt3 = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuId: 428,
          index: this.pagination3.currentPage3,
          size: this.pagination3.pagesize3,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst3 = this.arrLIst3.concat(res.data.Data.list);
            //   // 加载状态结束
            this.jzTxt3 = "点击加载更多";
            //   // 数据全部加载完成
            if (this.arrLIst3.length >= res.data.DataCount) {
              this.isLoad3 = false;
              this.jzTxt3 = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination3.currentPage3++;
    },
    //初始化列表  留学解答
    getData4() {
      this.jzTxt4 = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuId: 509,
          index: this.pagination4.currentPage4,
          size: this.pagination4.pagesize4,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst4 = this.arrLIst4.concat(res.data.Data.list);
            //   // 加载状态结束
            this.jzTxt4 = "点击加载更多";
            //   // 数据全部加载完成
            if (this.arrLIst4.length >= res.data.DataCount) {
              this.isLoad4 = false;
              this.jzTxt4 = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination4.currentPage4++;
    },
    //点击进入详情页
    handleClick(item, index) {
      this.$router.push({
        name: "listcontent",
        params: {
          id: item.WebsiteMenuId,
          WebsiteContentId: item.WebsiteContentId,
          html: "html",
        },
      });
    },
    //初始化列表  标签列表
    getLableData() {
      this.$axios
        .post("/trip/TokenPass/GetWebSiteLabelList", {
          CollegeId: 238,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.LabelList = res.data.Data;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dongguozixun {
  width: 750px;
  margin: 0 auto;
  margin-top: 134px;
  padding-top: 60px;
  margin-bottom: 80px;
  .titlebox {
    margin-left: 296px;
    margin-bottom: 50px;
    .title {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
    }
    .line {
      width: 60px;
      height: 8px;
      background: #f7901e;
      margin-top: -7px;
    }
  }
  .information {
    width: 670px;
    margin: 0 auto;
    .topbox {
      display: flex;
      align-items: center;
      .line {
        width: 4px;
        height: 28px;
        background: #ff8a00;
        margin-right: 20px;
      }
      .text {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        line-height: 30px;
      }
      .btnmore {
        display: block;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
        margin-left: auto;
      }
    }
    .list_Oul {
      li {
        padding: 26px 0;
        border-bottom: 1px solid #ebebeb;
        .abroadbox_text {
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          text-align: justify;
          overflow: hidden;
          white-space: nowrap;
          -o-text-overflow: ellipsis; /* for Opera */
          text-overflow: ellipsis; /* for IE */
        }
        .lablebox {
          margin-top: 14px;
          .abroadbox_lable {
            border: 1px solid #f48729;
            border-radius: 4px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f48729;
            height: 32px;
            padding-left: 10px;
            padding-right: 8px;
            margin-left: 10px;
            text-decoration: none;
          }
          .abroadbox_lable:nth-child(1) {
            margin-left: 0px;
          }
        }
      }
      li:nth-child(1) {
        // margin-top: 0px;
      }
    }
    .xiaoyuanzixunbox,
    .haiguizhengcebox,
    .liuxuejiedabox,
    .remenbiaoqian {
      margin-top: 50px;
    }
    .remenbiaoqian {
      .lablebox {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        .abroadbox_lable {
          border: 1px solid #f48729;
          border-radius: 4px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #f48729;
          height: 32px;
          padding-left: 10px;
          padding-right: 8px;
          margin-right: 10px;
          text-decoration: none;
          margin-top: 10px;
          display: block;
        }
        .abroadbox_lable:nth-child(1) {
          // margin-left: 0px;
        }
      }
    }
  }
  /deep/.problem_more {
    display: block;
    font-size: 22px;
    color: #fff;
    background: #f48729;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
    width: 100%;
    text-decoration: none;
    border-radius: 8px;
    letter-spacing: 1px;
  }
}
</style>